import React from "react";
import { Link } from "react-router-dom";
import { Button, Dropdown } from "react-bootstrap";
import { FaList, FaTh, FaPlus } from "react-icons/fa";
import { useLocation } from "react-router-dom";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
// import { Link } from "react-router-dom";
import { Breadcrumb, Col } from 'react-bootstrap';
const LeadsHeader =({ title, openModal })=> {
       const location = useLocation();
  return (
    <div  className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      {/* <div className="my-auto mb-2">
        <h2 className="mb-1">{title}</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item">CRM</li>
            <li className="breadcrumb-item active"></li>
          </ol>
        </nav>
      </div> */}
      <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Leads</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      CRM
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">{title}</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      <div className="d-flex align-items-center flex-wrap">
        {/* <div className="me-2 mb-2 d-flex border bg-white rounded p-1">
          <Link to="/leads-list" className="btn btn-sm btn-primary me-1">
          
          </Link>
          <Link to="/leads-grid" className="btn btn-sm btn-light">
            <FaTh />
          </Link>
        </div> */}

     
    <div className="d-flex me-3 border border-1 p-1 rounded rounded-1 mb-2">
      <Link
        to="/leads-list"
        className={`btn btn-icon btn-sm me-1 ${
          location.pathname === "/leads-list" ? "active-view" : ""
        }`}
      >
       <FaList />
      </Link>

      <Link
        to="/leads-grid"
        className={`btn btn-icon btn-sm ${
          location.pathname === "/leads-grid" ? "active-view" : ""
        }`}
      >
           <FaTh />
      </Link>
    </div>
        

        <Dropdown className="me-2 mb-2 border border-1">
          <Dropdown.Toggle variant="light">Export</Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button className="mb-2 add-contact" onClick={openModal}>
          <FaPlus className="me-2" /> Add Lead
        </Button>
      </div>
      <style>
          {

                    `.page-breadcrumb h2 {
  font-weight: 600;
}
.btn-primary {
  background-color: #ff6b00;
  border: none;
}
  .btn-primary:hover {
  background-color: #ff6b00;
  border: none;
}
  
  /* Default button */
.btn-icon {
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  transition: all 0.3s ease;
}

/* Hover effect (blue) */
.btn-icon:hover {
  background: #e0edff;
  color: #ff6b00;
  border-color: #ff6b00;
}
  .add-contact:hover{
  border-color: #ff6b00;
  
  }

/* ACTIVE state (orange like your design) */
.active-view {
  background-color: #ff6b00 !important;
  color: #fff !important;
  border-color: #ff6b00 !important;
}

/* Icon color inside */
.active-view i {
  color: #fff;
}
`
          }
      </style>
    </div>
  );
}
export default LeadsHeader;